import { InlineExternalLink } from '@monash/portal-react';

export const LINKS_EMPTY_VALUES = {
  name: '',
  icon: '',
  description: '',
  longDescription: '',
  categories: [],
  url: '',
  filters: [],
  tags: [],
  status: '',
  startDate: null,
};

export const LINKS_INLINE_ERROR_MSGS = {
  ICON: 'You must provide an icon',
  URL: 'You must provide a url',
  CATEGORY: 'You must select a category',
  SUB_CATEGORY: 'You must select a sub category',
  WEIGHT: 'Weight must be between 0-9',
};

export const MIN_WEIGHT = 0;

export const MAX_WEIGHT = 9;

// server error messages (5xx)
export const LINKS_SERVER_ERROR_MSGS = {
  DRAFT: "We're having trouble saving the link right now - please try again.",
  PUBLISH:
    "We're having trouble publishing the link right now - please try again.",
  DELETE:
    "We're having trouble deleting the link right now - please try again.",
  ARCHIVE:
    "We're having trouble archiving the link right now - please try again.",
};

// client error messages (4xx)
export const LINKS_CLIENT_ERROR_MSGS = {
  DRAFT: (
    <>
      We're having trouble saving the link - please{' '}
      <InlineExternalLink
        text="log a bug"
        link="https://admin.staff.monash/feedback"
      />
    </>
  ),
  PUBLISH: (
    <>
      We're having trouble publishing the link - please{' '}
      <InlineExternalLink
        text="log a bug"
        link="https://admin.staff.monash/feedback"
      />
    </>
  ),
  DELETE: (
    <>
      We're having trouble deleting the link - please{' '}
      <InlineExternalLink
        text="log a bug"
        link="https://admin.staff.monash/feedback"
      />
    </>
  ),
  ARCHIVE: (
    <>
      We're having trouble archiving the link - please{' '}
      <InlineExternalLink
        text="log a bug"
        link="https://admin.staff.monash/feedback"
      />
    </>
  ),
};
